import { render, staticRenderFns } from "./VUnverified.vue?vue&type=template&id=0f5dc050&"
import script from "./VUnverified.vue?vue&type=script&lang=js&"
export * from "./VUnverified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports